import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import {
  ezCheckHistoryItem,
  callToGetEZCheckValidatorHistoryPayload,
  exploreState,
  LicenseByZipParamsInterface,
  showDropdownEnum,
  BusinessDetailsEdited
} from '@/model/explore';
import { DealerFilterCollectionPayload } from '@/api/apis';
import { EditValuesToBeSavedInterface, FeesInterface } from '@/model/editDetails.mjs';
import {
  ErrorInterface,
  LicenseHistoryInterface,
  callToGetLicenseHistoryPayload
} from '@/model/licenseHistory.mjs';
import { bioTypeUpdate, ContactDetail, CustomAddress, licenseAttributeTypeUpdate, operationalStatusUpdateType } from '../types';
import { DefaultShippingAddress } from '@/model/licensee.mjs';
import { Recognizer } from '@masterffl/ffl-search-component';
import { ServicesTypeUpdate } from '@/dealerProfile/edit-dealer-profile/schema';
import { socialLinksName } from '@/dealerProfile/edit-dealer-profile/schemas';

type SavedFilterSuccessKind = 'save' | 'update' | 'delete';
type UpsertSavedFilterCollectionPayload = DealerFilterCollectionPayload & {
  kind?: Exclude<SavedFilterSuccessKind, 'delete'>;
};

export const businessDetailsEditedInitialValues = {
  phones: null,
  contacts: null,
  websites: null,
  emails: null
}

const transferFeeEditedInitialValues = {
  nics_fee: undefined,
  discount_multiple_firearms: undefined,
  suppressor_fee: undefined,
  pistol_fee: undefined,
  rifle_fee: undefined,
  sbr_fee: undefined,
  pistol_enabled: undefined,
  rifle_enabled: undefined,
  sbr_enabled: undefined,
}

const initialState: exploreState = {
  isEzCheckHistoryInprogress: false,
  isEzCheckHistoryInCompleted: false,
  isLicenseHistoryCompleted: false,
  ezCheckHistory: [],
  isCreateDealerActionInprogress: false,
  isCreateDealerActionCompleted: false,
  isDealerOptOut: false,
  dealerOptOutValue: '',
  licenseHistoryItem: [],
  isLicenseHistoryInprogress: false,
  showDropdown: null,
  LicenseByZipDistance: '5',
  filterList: [],
  licenseByZipQueryParams: {
    sortBy: 'preferred'
  },
  query: undefined,
  queryType: "",
  searchRecognizer: undefined,
  dealerActionsToBeSaved: [],
  businessDetailsEdited: businessDetailsEditedInitialValues,
  transferFeeEdited: transferFeeEditedInitialValues,
  contactDetailsEdit: null,
  customAddressEdit: null,
  optinOptoutEdited: "",
  isSendingDealerProfileEditEmail: false,
  isDealerProfileEditEmailSended: false,
  isLicenseRemoved: false,
  emailErrorState: [],
  bouncedEmailValidationError:"",
  contactDetailsError: [],
  newContactDetailsError: [],
  isBlacklisted:false,
  defaultShippingAddressEdited: null,
  isShootingRangeRevert:false,
  searchCount: 0,
  isSearchingDealer: false,
  isSearchStarted:true,
  suggestedResult: null,
  suggestedResultLoading: false,
  refreshSerpEnrichmentLoading: false,
  LicenseByState: [],
  savedFilterCollections: [],
  savedFilterCollectionsLoading: false,
  selectedSavedFilterId: null,
  savedFilterSuccessEvent: null
};

export const QueueSlice = createSlice({
  name: 'explore',
  initialState,
  reducers: {
    setIsEzCheckHistoryInprogress: (state, action: PayloadAction<boolean>) => {
      state.isEzCheckHistoryInprogress = action.payload;
    },
    setIsEzCheckHistoryCompleted: (state, action: PayloadAction<boolean>) => {
      state.isEzCheckHistoryInCompleted = action.payload;
    },
    setIsBlackListed: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isBlacklisted = action.payload;
    },
    setIsSearchStarted: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isSearchStarted = action.payload;
    },
    callToGetEZCheckValidatorHistory: (
      state,
      action: PayloadAction<callToGetEZCheckValidatorHistoryPayload>
    ) => { },
    setEZCheckHistory: (
      state,
      action: PayloadAction<Array<ezCheckHistoryItem>>
    ) => {
      state.ezCheckHistory = action.payload;
    },
    setIsCreateDealerActionInprogress: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isCreateDealerActionInprogress = action.payload;
    },
    setIsCreateDealerActionCompleted: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isCreateDealerActionCompleted = action.payload;
    },
    // saga
    callToCreateDealerAction: (
      state,
      action: PayloadAction<{
        actionList?: Array<EditValuesToBeSavedInterface>, addContactDetailsPayload?: { data: Array<ContactDetail>, licenseKey: string }, addCustomAddressPayload?: { data: Array<CustomAddress>, licenseKey: string }, removeContactDetailsIds?: Array<number>, removeCustomAddressIds?: Array<number>, updateContactDetails?: Array<ContactDetail>, updateCustomAddress?: Array<CustomAddress>, defaultShippingAddress?: { type: string, id?: string }, licenseKey?: string, dealerId?: string, socialLinksUpdatePayload?: {
          [socialLinksName: string]: string | null | undefined,
          name: string,
          license_key: string
          
      }[], operationalStatusUpdate?:operationalStatusUpdateType[], servicesUpdatePayload?: ServicesTypeUpdate[], licenseAttributeUpdatePayload?: licenseAttributeTypeUpdate[], bioUpdatePayload?: bioTypeUpdate[]} >
    ) => {},
    setIsDealerOptOut: (state, action: PayloadAction<boolean>) => {
      state.isDealerOptOut = action.payload;
    },
    setDealerOptOutValue: (state, action: PayloadAction<string>) => {
      state.dealerOptOutValue = action.payload;
    },
    setIsLicenseHistoryCompleted: (state, action: PayloadAction<boolean>) => {
      state.isLicenseHistoryCompleted = action.payload;
    },
    callToGetLicenseHistory: (
      state,
      action: PayloadAction<callToGetLicenseHistoryPayload>
    ) => { },
    setLicenseHistory: (
      state,
      action: PayloadAction<Array<LicenseHistoryInterface>>
    ) => {
      state.licenseHistoryItem = action.payload;
    },
    setIsLicenseHistoryInProgress: (state, action: PayloadAction<boolean>) => {
      state.isLicenseHistoryInprogress = action.payload;
    },
    setLicenseByZipQueryParams: (
      state,
      action: PayloadAction<LicenseByZipParamsInterface>
    ) => {
      state.licenseByZipQueryParams = action.payload;
    },
    setLicenseByZipDistance: (state, action: PayloadAction<string>) => {
      state.LicenseByZipDistance = action.payload;
    },
    setShowDropdownSlice: (
      state,
      action: PayloadAction<showDropdownEnum | null>
    ) => {
      state.showDropdown = action.payload;
    },
    setFilterList: (state, action: PayloadAction<Array<string>>) => {
      state.filterList = action.payload;
    },
    setQuery: (state, action: PayloadAction<Array<string> | undefined>) => {
      state.query = action.payload;
    },
    setQueryType: (state, action: PayloadAction<string | undefined>) => {
      state.queryType = action.payload;
    },
    setSearchRecognizer: (state, action: PayloadAction<Recognizer | undefined>) => {
      state.searchRecognizer = action.payload;
    },
    setDealerActionsToBeSaved: (state, action: PayloadAction<Array<EditValuesToBeSavedInterface>>) => {
      state.dealerActionsToBeSaved = action.payload;
    },
    setBusinessDetailsEdited: (state, action: PayloadAction<BusinessDetailsEdited>) => {
      state.businessDetailsEdited = action.payload;
    },
    setTransferFeeStatus: (state, action: PayloadAction<FeesInterface>) => {
      state.transferFeeEdited = action.payload;
    },
    setOptinOptoutEdited: (state, action: PayloadAction<string>) => {
      state.optinOptoutEdited = action.payload;
    },
    resetExploreSlice: () => initialState,
    resetTransferFeeEdited: (state) => {
      state.transferFeeEdited = transferFeeEditedInitialValues
    },
    resetBusinessDetails: (state) => {
      state.businessDetailsEdited = businessDetailsEditedInitialValues
    },
    callToSendProfileEditEmail: (state, action: PayloadAction<{ license_key: string }>) => {
    },
    setIsSendingDealerProfileEditEmail: (state, action: PayloadAction<boolean>) => {
      state.isSendingDealerProfileEditEmail = action.payload
    },
    setIsDealerProfileEditEmailSended: (state, action: PayloadAction<boolean>) => {
      state.isDealerProfileEditEmailSended = action.payload
    },
    setIsLicenseRemoved: (state, action: PayloadAction<boolean>) => {
      state.isLicenseRemoved = action.payload
    },
    callToRemoveLicense: (state, action: PayloadAction<{license_key: string, dealerId?: string, type: string}>) => {
    },
    setContactDetailsEdit: (state, action: PayloadAction<Array<ContactDetail> | null>) => {
      state.contactDetailsEdit = action.payload
    },
    setCustomAddressEdit: (state, action: PayloadAction<Array<CustomAddress> | null>) => {
      state.customAddressEdit = action.payload
    },
    setEmailErrorState: (state, action: PayloadAction<Array<ErrorInterface>>) => {
      state.emailErrorState = action.payload
    },
     setBouncedEmailErrorState: (state, action: PayloadAction<string>) => {
      state.bouncedEmailValidationError = action.payload
    },
    setNewContactDetailsError: (state, action: PayloadAction<Array<ErrorInterface>>) => {
      state.newContactDetailsError = action.payload
    },
    setContactDetailsError: (state, action: PayloadAction<Array<ErrorInterface>>) => {
      state.contactDetailsError = action.payload
    },
    setDefaultShippingAddressEdited: (state, action: PayloadAction<DefaultShippingAddress | null>) => {
      state.defaultShippingAddressEdited = action.payload
    },
    callToShootingChange: (state, action: PayloadAction<any>) => {
    },
    setIsShootingRevert: (state, action: PayloadAction<any>) => {
      state.isShootingRangeRevert = action.payload
    },
    setSearchCount: (state, action: PayloadAction<number>) => {
      state.searchCount = action.payload
    },
    setIsSearchingDealer: (state, action: PayloadAction<boolean>) => {
      state.isSearchingDealer = action.payload
    },
    setSuggestedResult: (state, action: PayloadAction<any>) => {
      state.suggestedResult = action.payload
    },
    setSuggestedResultLoading: (state, action: PayloadAction<boolean>) => {
      state.suggestedResultLoading = action.payload
    },
    callToSuggestedResult: (state, action: PayloadAction<string>) => {
    },
    callToRefreshSerpEnrichment: (state, action: PayloadAction<{ license_key: string }>) => {
    },
    setRefreshSerpEnrichmentLoading: (state, action: PayloadAction<boolean>) => {
      state.refreshSerpEnrichmentLoading = action.payload
    },
    setLicenseByState: (state, action: PayloadAction<string[]>) => {
      state.LicenseByState = action.payload;
    },
    setSavedFilterCollections: (state, action: PayloadAction<any[]>) => {
      state.savedFilterCollections = action.payload;
    },
    setSavedFilterCollectionsLoading: (state, action: PayloadAction<boolean>) => {
      state.savedFilterCollectionsLoading = action.payload;
    },
    setSelectedSavedFilterId: (state, action: PayloadAction<string | null>) => {
      state.selectedSavedFilterId = action.payload;
    },
    setSavedFilterSuccessEvent: (
      state,
      action: PayloadAction<{ kind: SavedFilterSuccessKind; name: string } | null>
    ) => {
      state.savedFilterSuccessEvent = action.payload;
    },
    callToGetSavedFilterCollections: (state, action: PayloadAction<{ type: string }>) => {
    },
    callToUpsertSavedFilterCollection: (state, action: PayloadAction<UpsertSavedFilterCollectionPayload>) => {
    },
    callToDeleteSavedFilterCollection: (
      state,
      action: PayloadAction<{ id: string; type: string; name: string }>
    ) => {
    },
  }
});

export const {
  setIsEzCheckHistoryInprogress,
  setIsEzCheckHistoryCompleted,
  setIsBlackListed,
  setIsSearchStarted,
  setEZCheckHistory,
  setIsCreateDealerActionInprogress,
  setIsCreateDealerActionCompleted,
  setQuery,
  setQueryType,
  setSearchRecognizer,
  setIsLicenseHistoryInProgress,
  setLicenseByZipQueryParams,
  setLicenseByZipDistance,
  setShowDropdownSlice,
  setFilterList,
  setIsDealerOptOut,
  setDealerOptOutValue,
  setIsLicenseHistoryCompleted,
  setLicenseHistory,
  setDealerActionsToBeSaved,
  setBusinessDetailsEdited,
  setTransferFeeStatus,
  setOptinOptoutEdited,
  resetTransferFeeEdited,
  resetBusinessDetails,
  resetExploreSlice,
  setIsDealerProfileEditEmailSended,
  setIsSendingDealerProfileEditEmail,
  setContactDetailsEdit,
  setCustomAddressEdit,
  setEmailErrorState,
  setBouncedEmailErrorState,
  setNewContactDetailsError,
  setContactDetailsError,
  setDefaultShippingAddressEdited,
  setIsSearchingDealer,
  setSuggestedResult,
  setSuggestedResultLoading,
  setRefreshSerpEnrichmentLoading,
  setSavedFilterCollections,
  setSavedFilterCollectionsLoading,
  setSelectedSavedFilterId,
  setSavedFilterSuccessEvent,
  // saga
  callToGetEZCheckValidatorHistory,
  callToCreateDealerAction,
  callToGetLicenseHistory,
  callToSendProfileEditEmail,
  setIsLicenseRemoved,
  callToRemoveLicense,
  callToShootingChange,
  callToSuggestedResult,
  callToRefreshSerpEnrichment,
  setIsShootingRevert,
  setSearchCount,
  setLicenseByState,
  callToGetSavedFilterCollections,
  callToUpsertSavedFilterCollection,
  callToDeleteSavedFilterCollection
} = QueueSlice.actions;

export default QueueSlice.reducer;
